import Link from 'next/link';
import { useRouter } from 'next/router';
import { type ReactNode } from 'react';
import { ConnectedPersonIcon } from '@/components/account/uielements';
import { styled } from '@/components/content/stitches';
import { ROUTES } from '@/constants/routes';
import { deriveReferrer } from '@/utils/global';

interface Props {
  children?: ReactNode;
}

export function Signin({ children }: Props) {
  const router = useRouter();
  const loginReferrer = deriveReferrer(router);

  return (
    <HeaderIconLink
      href={`${ROUTES.LOGIN}?referrer=${loginReferrer}`}
      data-css-override="StyledLinkWithIcon"
      aria-label="Log in"
    >
      <ConnectedPersonIcon />
      {children}
    </HeaderIconLink>
  );
}

/** The header's icon + label link; shared by "Sign In/Join" and the signed-in fallback. */
export const HeaderIconLink = styled(Link, {
  alignItems: 'center',
  background: 'none',
  cursor: 'pointer',
  display: 'flex',
  gap: '$2-5',
  textDecoration: 'none',
  color: 'inherit',
});
